import { defineMessages } from "react-intl";

const messages = defineMessages({
    underDevelopment: {
        id: "languages.underDevelopment",
    },
});

export default messages;
